import { render, staticRenderFns } from "./VSelectOption.vue?vue&type=template&id=58c95e5c"
import script from "./VSelectOption.vue?vue&type=script&lang=js"
export * from "./VSelectOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports